import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

export function useIsDesktop(): boolean {
  const theme = useTheme();
  const [isDesktop, setIsDesktop] = useState(false);

  const onDesktopWidthHandler = useCallback((e: MediaQueryListEvent) => {
    setIsDesktop(e.matches);
  }, []);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(
      `(min-width: ${theme.breakpoints_md})`
    );

    setIsDesktop(mediaQueryList.matches);

    mediaQueryList.addEventListener('change', onDesktopWidthHandler);
  }, [theme.breakpoints_md, onDesktopWidthHandler]);

  return isDesktop;
}
